import getSellingPriceForSellerQuery from './getSellingPriceForSellerQuery';
import { searchSparePartsByNames } from './searchSparePartsByNames';

export const CommonSparePartsService = {
  searchSparePartsByNames,
  getSellingPriceForSellerQuery,
};
